<template>
    <ui-card-toggle>
        <template #title>{{ data.subtitle }}</template>
        <template #content>
            <section class="main">
                <div class="desc">{{ data.description }}</div>
                <section class="filters">
                    <div v-if="data.param && data.param.fields">
                        <div v-if="Array.isArray(data.param.fields)">
                            <div v-for="field in data.param.fields" :key="field.id">
                                <div
                                    v-if="
                                        field.type &&
                                            field.type == 'input' &&
                                            field.name == 'rangeDateCust'
                                    "
                                >
                                    <div class="placeholder">
                                        <strong>Informe o período:</strong>
                                    </div>
                                    <ui-date-range
                                        v-model="filterInput"
                                        placeholder="Informe o período"
                                        :hide-options="['Hoje']"
                                        :same-or-upper-today="false"
                                    />
                                </div>
                                <div v-else-if="field.type && field.type == 'input'">
                                    <div class="placeholder">
                                        <strong>{{ getCorrectPlaceholder(field) }}:</strong>
                                    </div>
                                    <ui-input
                                        v-model="filterInput"
                                        :type="field.input"
                                        :name="field.name"
                                        :placeholder="field.placeholder"
                                    />
                                </div>
                                <div v-else>
                                    <div class="placeholder">
                                        <strong>{{ getCorrectPlaceholder(field) }}:</strong>
                                    </div>
                                    <ui-select-2
                                        v-model="filterInput"
                                        :data="getCorrectInputData(field)"
                                        :placeholder="getCorrectPlaceholder(field)"
                                        :search="false"
                                        item-label="name"
                                        return-value="id"
                                    />
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div
                                v-if="
                                    data.param.fields.type &&
                                        data.param.fields.type == 'input' &&
                                        data.param.fields.name == 'rangeDateCust'
                                "
                            >
                                <div class="placeholder">
                                    <strong>Informe o período:</strong>
                                </div>
                                <ui-date-range
                                    v-model="filterInput"
                                    placeholder="Informe o período"
                                    :all-dates="false"
                                    :same-or-upper-today="false"
                                />
                            </div>
                            <div
                                v-else-if="
                                    data.param.fields.type && data.param.fields.type == 'input'
                                "
                            >
                                <div class="placeholder">
                                    <strong>{{ getCorrectPlaceholder(data.param.fields) }}:</strong>
                                </div>
                                <ui-input
                                    v-model="filterInput"
                                    :type="data.param.fields.input"
                                    :name="data.param.fields.name"
                                    :placeholder="data.param.fields.placeholder"
                                />
                            </div>
                            <div v-else>
                                <div class="placeholder">
                                    <strong>{{ getCorrectPlaceholder(data.param.fields) }}:</strong>
                                </div>
                                <ui-select-2
                                    v-model="filterInput"
                                    :data="getCorrectInputData(data.param.fields)"
                                    :placeholder="getCorrectPlaceholder(data.param.fields)"
                                    :search="false"
                                    item-label="name"
                                    return-value="id"
                                />
                            </div>
                        </div>
                    </div>
                    <div v-else><strong>Não há opções de filtros...</strong></div>
                </section>
                <section class="actions" :style="getActionsStyle">
                    <div v-if="reportResponse.csv != ''">Relatório gerado em: {{ today }}</div>
                    <ui-button
                        v-if="reportResponse.csv == ''"
                        :loading="loader.generateReport"
                        design="md success"
                        @click="generateReport"
                    >
                        Gerar Relatório
                    </ui-button>
                    <ui-button v-else design="md primary" @click="openDownloadModal">
                        Baixar
                    </ui-button>
                </section>
            </section>
        </template>
    </ui-card-toggle>
</template>

<script>
	import { uiCardToggle } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput, uiSelect2, uiDateRange } from '@/components/ui/form'

	import { reports } from '@/services/axios'

	const moment = require('moment')
	require('moment/locale/pt-br')

	const defaultLoader = () => ({
		generateReport: false,
	})

	export default {
		name: 'report-card',

		components: {
			uiCardToggle,
			uiButton,
			uiInput,
			uiSelect2,
			uiDateRange,
		},

		props: {
			data: { type: Object, required: true },
			teams: { type: Array, required: true },
			products: { type: Array, required: true },
		},

		data() {
			return {
				dataType: null,
				filterInput: null,

				reportResponse: { reportName: '', csv: '', xlsx: '' },

				today: moment().format('DD/MM/YYYY'),
				loader: { ...defaultLoader() },
			}
		},

		computed: {
			// Return valid actions section style
			getActionsStyle() {
				return this.reportResponse.csv != '' ? '' : 'flex-direction: row-reverse'
			},
		},

		watch: {
			// If something changed in the input, let it be able to generate a new report
			filterInput(newVal, oldVal) {
				if (newVal != oldVal) {
					this.reportResponse.reportName = ''
					this.reportResponse.csv = ''
					this.reportResponse.xlsx = ''
				}
			},
		},

		created() {
			this.synchronizeDataType()
		},

		methods: {
			// Request the report generation in the API
			async generateReport() {
				if (this.dataType != null && (this.filterInput == null || this.filterInput == '')) {
					this.$toastr.e(
						'Impossível continuar, escolha um filtro de pesquisa válido e tente novamente!',
					)
					return
				}

				try {
					this.loader.generateReport = true

					const response = await reports.bytype(
						this.data.fileName,
						this.getCorrectData(this.dataType, this.filterInput),
					)

					// Has error
					if (response.data.status == 'error' || response.data.msg) {
						this.loader.generateReport = false
						this.$toastr.e('Ocorreu um erro ao solicitar o relatório, tente novamente!')
						return
					}

					this.reportResponse.reportName = response.data.reportName
					this.reportResponse.csv = response.data.urls.csv
					if (response.data.urls.xlsx) this.reportResponse.xlsx = response.data.urls.xlsx

					this.loader.generateReport = false
				} catch {
					this.loader.generateReport = false
					this.$toastr.e('Ocorreu um erro ao solicitar o relatório, tente novamente!')
				}
			},

			// Synchronize input data according to the report reference
			getCorrectInputData(field) {
				switch (field.reference) {
					case 'products':
						return this.products
					case 'teams':
						return this.teams
					case 'productsAvailability':
						return this.products
					case 'period':
						if (!field.blocked || (field.blocked && field.blocked != 'semester'))
							return [
								{ id: 0, name: '1º semestre' },
								{ id: 1, name: '2º semestre' },
							]
						else if (!field.blocked || (field.blocked && field.blocked != 'trimester'))
							return [
								{ id: 0, name: '1º semestre' },
								{ id: 1, name: '2º semestre' },
								{ id: 2, name: '3º semestre' },
								{ id: 3, name: '4º semestre' },
							]

						return null
					default:
						return null
				}
			},

			// Sync placeholder according to report reference
			getCorrectPlaceholder(field) {
				switch (field.reference) {
					case 'negocios_completos':
						return 'Informe uma data'
					case 'products':
						return 'Informe um empreendimento'
					case 'teams':
						return 'Informe uma equipe'
					case 'productsAvailability':
						return 'Informe um empreendimento'
					case 'period':
						return 'Informe o período'
					case 'availability_units_reserves':
						return 'Informe o identificador da unidade'
					default:
						return 'Informe'
				}
			},

			// Sync payload according to report type
			getCorrectData(type, input) {
				switch (type) {
					case 'initialDateCust':
						return { fromType: 'csv', toType: 'xlsx', initialDateCust: input }
					case 'initialDateDeal':
						return { fromType: 'csv', toType: 'xlsx', initialDateDeal: input }
					case 'rangeDateCust':
						return {
							fromType: 'csv',
							toType: 'xlsx',
							date_range: this.formatFirstDateLastDate(input),
						}
					case 'id_team':
						return { fromType: 'csv', toType: 'xlsx', id_team: input }
					case 'id_produto':
						return { fromType: 'csv', toType: 'xlsx', id_produto: input }
					case 'id_unidade':
						return { fromType: 'csv', toType: 'xlsx', id_unidade: input }
					case 'year':
						return { fromType: 'csv', toType: 'xlsx', year: input }
					default:
						return { fromType: 'csv', toType: 'xlsx' }
				}
			},

			// Format the first data and last date for the payload
			formatFirstDateLastDate(input) {
				const dates = input.split('_')
				return `firstDate_${dates[0]} 00:00:00_lastDate_${dates[1]} 23:59:59`
			},

			// See what type of report is in question to sync the payload in the future
			synchronizeDataType() {
				if (!this.data.param || !this.data.param.fields) return

				if (Array.isArray(this.data.param.fields)) {
					this.data.param.fields.forEach((field) => {
						this.dataType = field.name
					})

					return
				}

				this.dataType = this.data.param.fields.name
			},

			// Emit event to open download modal
			openDownloadModal() {
				// Send data to modal
				this.$root.$emit('athena-reports-download-report', {
					subtitle: this.data.subtitle,
					reportResponse: this.reportResponse,
				})

				// Open modal
				this.$root.$emit('modal-open-report-download-modal')
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
